<template>
  <div class="advanced-approval-settings">
    <el-table :data="formBuilder.advanced_approval_users" style="width: 50%">
      <el-table-column label="#" width="50">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="Role">
        <template v-slot="scope">
          <el-select
            v-model="scope.row.role"
            placeholder="Select role"
            size="small"
            style="width: 100%"
            clearable
          >
            <el-option label="User" value="user" />
            <el-option label="Approver" value="approver" />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="User">
        <template v-slot="scope">
          <div
            style="display: flex; align-items: center; gap: 8px"
            v-if="scope.row.role === 'user'"
          >
            <el-select
              v-model="scope.row.user_usertype"
              placeholder="Select user type"
              size="small"
              style="flex: 1"
              :default-first-option="true"
              clearable
            >
              <el-option label="Edit" value="edit" />
              <el-option label="Preview" value="preview" />
            </el-select>
          </div>
          <div style="display: flex; align-items: center; gap: 8px" v-else>
            <el-select
              v-if="scope.row.role === 'approver'"
              v-model="scope.row.approver_type"
              placeholder="Select approver user type"
              size="small"
              style="flex: 1"
              clearable
            >
              <el-option-group label="Constant approver">
                <el-option
                  label="Approver from the application saved contacts"
                  value="constant_approver"
                />
              </el-option-group>

              <el-option-group label="Dynamic approver">
                <el-option
                  label="Attribute based"
                  value="dynamic_attribute_based"
                />
              </el-option-group>
            </el-select>
            <el-tooltip content="Config approvers" placement="top">
              <el-button
                v-if="scope.row.role && scope.row.role !== 'user'"
                type="text"
                icon="el-icon-s-tools"
                @click="
                  openApproversConfig(scope.row.approver_type, scope.$index)
                "
              >
              </el-button>
            </el-tooltip>
            <el-tooltip content="Field Level Permissions" placement="top" v-if="formBuilder.allow_field_level_permissions">
              <el-button
                v-if="scope.row.role && scope.row.role !== 'user'"
                type="text"
                icon="el-icon-key"
                @click="
                  openFormBuilderSettings(scope.row.approver_type, scope.$index)
                "
              >
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Business Rules" width="140">
        <template v-slot="scope">
          <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
            <el-tooltip content="Business Rules" placement="top">
              <el-button type="text" @click="openBusinessRulesConfig(scope.$index)">
                <img src="@/assets/img/business-rules.svg" alt="icon" />
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Delete" width="70">
        <template v-slot="scope">
          <el-link icon="el-icon-delete" :underline="false" @click="removeLevel(scope.$index)"></el-link>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Complete Workflow" width="100">
        <template v-slot="scope">
          <el-checkbox v-model="scope.row.is_complete_workflow"></el-checkbox>
        </template>
      </el-table-column> -->
    </el-table>

    <el-button
      type="primary"
      size="mini"
      @click="addLevel"
      icon="el-icon-plus"
      class="mt-1"
      >Add level</el-button
    >
    <el-button
      v-if="formBuilder.advanced_approval_users.length"
      type="primary"
      size="mini"
      @click="reConfig"
      icon="el-icon-refresh"
      class="mt-1"
      >Reconfig</el-button
    >

    <dialog-component
      :visible="openConstantApproversModel"
      title="Approvers from the application saved contacts"
      @before-close="closeConstantApproversModel"
      :containerWidth="'55%'"
      :containerHeight="'58%'"
    >
      <div class="p-4">
        <span class="warning">
          <i class="el-icon-info"></i> To configure the approvers for the level
          {{ " - " + (currentLevelIndex + 1) }}, please add the approvers below.
        </span>
        <el-row
          v-for="(user, i) in formBuilder?.advanced_approval_users?.[
            currentLevelIndex
          ]?.constant_approvers"
          :key="'user_' + i"
          class="mt-1"
        >
          <el-col :span="4" class="ml-1">
            <el-select
              v-model="user.user_type"
              size="mini"
              clearable
              placeholder="Select user type"
              @change="updateUserType(i)"
            >
              <el-option
                v-for="userType in userTypes"
                :key="userType.value"
                :label="userType.label"
                :value="userType.value"
              ></el-option>
              <el-option
                v-for="(advUser) in previousLevelsProfileApprovers"
                :key="advUser.value"
                :label="advUser.label"
                :value="advUser.value"
              ></el-option>
            </el-select>
          </el-col>
          <template v-if="user.user_type == 'COMPANY'">
            <el-col :span="4">
              <el-select
                v-model="user.company_user_type"
                clearable
                size="mini"
                @change="(value) => updateCompanyUsers(value, user)"
                placeholder="Select company user type"
                class="ml-1"
              >
                <el-option
                  v-for="item in getUserTypeList"
                  :key="item._id"
                  :label="getLabel(item)"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select
                v-if="user.company_user_type"
                v-model="user.preferred_company_users"
                collapse-tags
                clearable
                size="mini"
                multiple
                placeholder="Select preferred user"
                class="ml-1"
                default-first-option
              >
                <el-option
                  v-for="item in getCompanyUsersByType(user.company_user_type)"
                  :key="item._id + '_company_user'"
                  :label="item.email"
                  :value="item._id"
                  >{{ item.email }}</el-option
                >
              </el-select>
            </el-col>
            <!-- <el-col :span="4" class="mr-1">
              <el-checkbox
                class="ml-1"
                v-if="getCompanyUsersByType(user.company_user_type).length > 1"
                v-model="user.any_user_can_approve"
                >Any user can approve</el-checkbox
              >
            </el-col> -->
          </template>
          <template v-else-if="user.user_type == 'APPLICATION'">
            <el-col :span="4">
              <el-select
                v-model="user.application_user_type"
                clearable
                size="mini"
                @change="updateApplicationUserType(user)"
                placeholder="Select application user type"
                class="ml-1"
              >
                <el-option
                  v-for="(type, index) in getAllContactTypes.data ||
                  getAllContactTypes"
                  :key="index + 1"
                  :value="type._id"
                  :label="type.name"
                  >{{ type.name }}</el-option
                >
              </el-select>
            </el-col>
            <el-col :span="4">
              <div v-if="checkIsIndividualEntityUserType(user.application_user_type)">
                <el-select
                  v-model="user.individual_entity_resource"
                  clearable
                  size="mini"
                  placeholder="Select resource"
                  class="ml-1"
                  @change="getFiltersByEntityId(user.application_user_type)"
                >
                  <el-option
                    v-for="(type, index) in resourceTypes"
                    :key="index + 1"
                    :value="type.value"
                    :label="type.label"
                    >{{ type.label }}</el-option
                  >
                </el-select>
              </div>
            </el-col>
            <el-col :span="4">
              <div v-if="user.individual_entity_resource == 'FILTER'">
                <el-select
                  v-model="user.filter_type"
                  clearable
                  size="mini"
                  placeholder="Select filter type"
                  class="ml-1"
                >
                  <el-option
                    v-for="(type, index) in filterTypes"
                    :key="index + 1"
                    :value="type.value"
                    :label="type.label"
                    >{{ type.label }}</el-option
                  >
                </el-select>
              </div>
            </el-col>
            <el-col :span="3">
              <div v-if="user.application_user_type && user.individual_entity_resource == 'FILTER' && user.filter_type == 'SAVED_FILTER'">
                <el-select
                  v-model="user.selected_entity_filter"
                  filterable
                  clearable
                  placeholder="Select filter"
                  size="mini"
                  class="ml-1"
                  @change="updateFilterName(user.selected_entity_filter, i)"
                >
                  <el-option
                    v-for="(filter, index) in entityFilters"
                    :key="index"
                    :label="filter.filter_name"
                    :value="filter._id"
                  />
                </el-select>
              </div>
            </el-col>
            <el-col :span="1">
              <div v-if="user.application_user_type && user.individual_entity_resource == 'FILTER' && user.filter_type == 'CONFIGURE_FILTER'">
                <el-tooltip content="Add Filters" placement="top">
                  <el-button
                    :style="'margin-left: 5px; margin-right: 5px;'"
                    size="mini"
                    type="plain"
                    icon="el-icon-plus"
                    @click="addFiltersForConstantApprovers(i)">
                  </el-button>
                </el-tooltip>
              </div>
            </el-col>
            <el-col :span="4">
              <div v-if="checkIsBusinessUserType(user.application_user_type)">
                <el-select
                  v-model="user.business_account_type"
                  clearable
                  size="mini"
                  placeholder="Select business application user type"
                  class="ml-1"
                  @change="getBusinessAccountNames(user.application_user_type)"
                >
                  <el-option
                    v-for="(type, index) in accountTypes"
                    :key="index + 1"
                    :value="type.value"
                    :label="type.label"
                    >{{ type.label }}</el-option
                  >
                </el-select>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="ml-1"
                v-if="
                  user.application_user_type &&
                  user.business_account_type == 'GROUP'
                "
              >
                <el-select
                  v-model="user.application_user_business_account_id"
                  clearable
                  size="mini"
                  placeholder="Select business account"
                  @change="updatePreferredApplicationUsers(user)"
                >
                  <el-option
                    v-for="(account, i) in accountNamesObj[
                      user.application_user_type
                    ]"
                    :key="i"
                    :value="account._id"
                    :label="getLabelForBusinessAccount(account)"
                  >
                    {{ getLabelForBusinessAccount(account) }}
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="4">
              <div
                class="ml-1"
                v-if="
                  user.application_user_type &&
                  user.business_account_type !== 'GROUP' &&
                  user.individual_entity_resource !== 'FILTER'
                "
              >
                <el-select
                  v-model="user.preferred_application_users"
                  collapse-tags
                  clearable
                  multiple
                  size="mini"
                  placeholder="Select preferred user"
                  :disabled="user.relational_user"
                >
                  <el-option
                    v-for="(contact, index) in getUserTypeContacts(
                      user.application_user_type
                    )"
                    :key="index + '_application_user_mail'"
                    :value="contact.email"
                    :label="contact.email"
                    >{{ contact.email }}</el-option
                  >
                </el-select>
                <el-checkbox
                  v-if="checkIsRelational(user.application_user_type)"
                  :disabled="
                    user.preferred_application_users &&
                    user.preferred_application_users.length
                      ? true
                      : false
                  "
                  v-model="user.relational_user"
                  >User relational data</el-checkbox
                >
              </div>
            </el-col>
            <!-- <el-col :span="4" class="mr-1">
              <el-checkbox
                class="ml-1"
                v-if="
                  getUserTypeContacts(user.application_user_type).length > 1 &&
                  !user.relational_user
                "
                v-model="user.any_user_can_approve"
                >Any user can approve</el-checkbox
              >
            </el-col> -->
          </template>
          <template v-else-if="user.user_type == 'LINKEDFIELD'">
            <el-col :span="4">
              <el-select
                v-model="user.approval_linked_field"
                clearable
                size="mini"
                placeholder="Select user data field"
                class="ml-1"
              >
                <el-option
                  v-for="(option, index) of getAllFields"
                  :key="index"
                  :value="option.key"
                  :label="option.label"
                  :disabled="
                    checkDuplicate(i, option.key, 'approval_linked_field')
                  "
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-col>
          </template>
          <template v-else-if="user.user_type == 'USER_PROFILE'">
            <el-col :span="6">
              <el-select
                v-model="user.user_profile_field"
                clearable
                size="mini"
                placeholder="Select a field from the user profile"
                class="ml-1"
              >
                <el-option
                  v-for="(option, index) of userProfileFields"
                  :key="index"
                  :value="option.key"
                  :label="option.label"
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-col>
          </template>
          <template v-else-if="user.user_type.includes('related-to#levelIndex')">
            <el-col :span="6">
              <el-select
                v-model="user.user_profile_field"
                clearable
                size="mini"
                placeholder="Select a field"
                class="ml-1"
              >
                <el-option
                  v-for="(option, index) of userProfileFields"
                  :key="index"
                  :value="option.key"
                  :label="option.label"
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-col>
          </template>
          <template>
            <el-col :span="1">
              <el-link
                class="ml-1"
                icon="el-icon-delete"
                :underline="false"
                type="danger"
                @click="removeConstantApprover(i)"
              ></el-link>
            </el-col>
          </template>
        </el-row>
        <el-row class="mt-1">
          <el-button
            class="mt-1 ml-1"
            type="primary"
            plain
            size="mini"
            icon="el-icon-plus"
            @click="addApprovers"
            >Add Approvers</el-button
          >
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeConstantApproversModel">
          Save
        </el-button>
        <el-button @click="closeConstantApproversModel"> Cancel </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :visible="openAttributeBasedApproversModel"
      :containerWidth="'83%'"
      :containerHeight="'95%'"
      title="Attribute based dynamic approvers"
      @before-close="closeAttributeBasedApproversModel"
      class="dialogStyle"
    >
      <AttributeBasedSettings
        :getAllContactTypes="getAllContactTypes"
        :allFormbuilderFields="allFormbuilderFields"
        :attributeData="formBuilder.advanced_approval_users[currentLevelIndex]"
        :allEntities="allEntitiesData"
        :isFromBusinessRules="false"
        :company_users="company_users"
        :allContacts="allContacts"
        :formBuilder="formBuilder"
      ></AttributeBasedSettings>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="closeAttributeBasedApproversModel"
          >Save</el-button
        >
        <el-button size="mini" @click="closeAttributeBasedApproversModel"
          >Cancel</el-button
        >
      </span>
    </dialog-component>
    <dialog-component
      :visible="openBusinessRulesModel"
      :containerWidth="'70%'"
      :containerHeight="'80%'"
      :title="'Level-' + (currentLevelIndex + 1) + ' Business Rules'"
      @before-close="closeBusinessRulesModel"
    >
      <div class="p-4">
        <AttributeBasedSettings
          :getAllContactTypes="getAllContactTypes"
          :allFormbuilderFields="allFormbuilderFields"
          :attributeData="
            formBuilder.advanced_approval_users[currentLevelIndex]
          "
          :allEntities="allEntitiesData"
          :isFromBusinessRules="true"
          :currentLevelIndex="currentLevelIndex"
          :company_users="company_users"
          :allContacts="allContacts"
          :formBuilder="formBuilder"
        ></AttributeBasedSettings>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeBusinessRulesModel">
          Save
        </el-button>
        <el-button @click="closeBusinessRulesModel">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :visible="openConstantApproverFilters"
      :containerWidth="'63%'"
      :containerHeight="'75%'"
      title="Add filtered approval users"
      @before-close="closeConstantApproverFilters"
    >
      <div class="p-3">
        <AttributeBasedSettings
          :getAllContactTypes="getAllContactTypes"
          :allFormbuilderFields="allFormbuilderFields"
          :attributeData="formBuilder.advanced_approval_users[currentLevelIndex]"
          :allEntities="allEntitiesData"
          :isFromBusinessRules="false"
          :company_users="company_users"
          :allContacts="allContacts"
          :formBuilder="formBuilder"
          :constantApproverIndex="constantApproverIndex"
          :selectedEntityFields="selectedEntityFields"
          :currentEntity="currentEntity"
          :isFromConstantApproverFilters="true"
        ></AttributeBasedSettings>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="closeConstantApproverFilters"
          >Save</el-button
        >
        <el-button size="mini" @click="closeConstantApproverFilters"
          >Cancel</el-button
        >
      </span>
    </dialog-component>
     <dialog-component
      :title="'Field Level Permissions'"
      :visible="fieldLevelPermissionsModal"
      @before-close="saveCustomization"
      :isShowFooter="false"
      :containerWidth="'40%'"
    >
      <div>
        <FieldLevelPermissions
          :templateData="allFormBuilderOriginalFields"
          :customization="selectedFormBuilderCustomization"
          :fromFormbuilder="true"
          @updateCustomization="handleUpdate"
        ></FieldLevelPermissions>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import { fetchEntityById } from "../../repo/entityRepo";
import { fetchAllEntityFiltersByEntity } from "@/repo/filtersRepo";
import ApprovalsHelper from "@/mixins/ApprovalsHelper";
import { postAPICall } from "../../helpers/httpHelper";
import TemplateBuilderhelper from "@/mixins/templateBuilderHelper.js";

export default {
  name: "AdvancedApprovalSettings",
  props: {
    formBuilder: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    getUserTypeList: {
      type: Array,
    },
    allEntitiesData: {
      type: Array,
    },
    relationshipsData: {
      type: Array,
    },
    getAllContactTypes: {
      type: Array,
    },
    allContacts: {
      type: Array,
    },
    getAllFields: {
      type: Array,
    },
    company_users: {
      type: Array,
    },
    allFormbuilderFields: {
      type: Array,
    },
    allFormBuilderOriginalFields: {
      type: Array,
    }
  },
  data() {
    return {
      userProfileFields: [],
      currentEntity: {},
      selectedEntityFields: [],
      entityFilters: [],
      openConstantApproverFilters: false,
      constantApproverIndex: 0,
      openBusinessRulesModel: false,
      openUserConfigModel: false,
      openConstantApproversModel: false,
      openAttributeBasedApproversModel: false,
      openPreviousApproversModel: false,
      currentLevelIndex: 0,
      accountNamesObj: {},
      mappedEntityPrimaryFields: {},
      previousLevelApproverEntityFields: [],
      userTypes: [
        { value: "APPLICATION", label: "Application Users" },
        { value: "COMPANY", label: "Company Users" },
        { value: "LINKEDFIELD", label: "Based on filled data" },
        { value: "USER_PROFILE", label: "Related to User Profile (Filling User Profile)" },
      ],
      accountTypes: [
        { value: "GROUP", label: "Group" },
        { value: "SPECIFIC_USER", label: "Specific User" },
      ],
      resourceTypes: [
        { value: "FILTER", label: "Group" },
        { value: "SPECIFIC_USER", label: "Specific User" },
      ],
      filterTypes: [
        { value: "SAVED_FILTER", label: "Saved Filters" },
        { value: "CONFIGURE_FILTER", label: "Add new filter" },
      ],
      fieldLevelPermissionsModal:false,
      selectedFormBuilderCustomization:{},
      fieldPermissionKey : null
    };
  },
  mixins: [ApprovalsHelper,TemplateBuilderhelper],
  components: {
    AttributeBasedSettings: () => import("./attributeBasedSettings.vue"),
    FieldLevelPermissions: () => import("../entity/FieldLevelPermissions.vue"),
  },
  computed: {
    getLabel() {
      return (userType) => {
        if (userType && userType.role) {
          return userType.role.title + " - " + userType.name;
        } else {
          return userType.name;
        }
      };
    },
    showLinkedFieldSelector() {
      return (
        this.formBuilder.advanced_approval_users[this.currentLevelIndex]
          ?.selected_previous_level && this.isBasedOnFilledDataApproverLevel()
      );
    },
  },
  async mounted() {
    await this.getFillingUserProfileFields();
  },
  methods: {
    removeLevel(levelIndex) {
      this.formBuilder.advanced_approval_users.splice(levelIndex, 1);
    },
    async getFillingUserProfileFields() {
      let fields = [];
      if (this.formBuilder.form_builders_owner == "ENTITY" && this.formBuilder?.entity_id) {
        fields = await this.getEntityFields(this.formBuilder.entity_id);
        fields = fields
          .filter(f => f.input_type === "ENTITY")
          .map(f => ({
            ...f,
            key: `${f.entity_id}#${f.key}`,
          }));
        this.userProfileFields = fields;
      }
    },
    getLevelProfileRelatedApprovers() {
      let profileApprovers = [];
      this.formBuilder.advanced_approval_users.forEach((app, index) => {
        if (app.role === "user" && index !== 0) {
          profileApprovers.push({
            label: `Related to Level-${index + 1} user profile`,
            value: `related-to#levelIndex-${index}`,
          });
        } else if (
          app.role === "approver" &&
          app.approver_type === "constant_approver" &&
          app?.constant_approvers?.length
        ) {
          let findProfileApprover = app.constant_approvers.find(
            (e) => (e.user_type === "USER_PROFILE" || e?.user_type?.includes("related-to#")) && e?.user_profile_field && this.currentLevelIndex !== index
          );

          if (findProfileApprover) {
            profileApprovers.push({
              label: `Related to Level-${index + 1} Approver`,
              value: `related-to#levelIndex-${index}`,
            });
          }
        }
      });
      this.previousLevelsProfileApprovers = profileApprovers;
    },
    async getFiltersByEntityId(entityId) {
      const getAllEntityFilters = await fetchAllEntityFiltersByEntity({
        entityId: entityId,
      });
      this.entityFilters = getAllEntityFilters;
    },
    updateFilterName(filter_id, index) {
      let filterData = this.entityFilters.find(f => f._id == filter_id);
      this.formBuilder.advanced_approval_users[this.currentLevelIndex].constant_approvers[index].filter_name = filterData.filter_name;
    },
    async addFiltersForConstantApprovers(constantApproverIndex) {
      this.openConstantApproverFilters = true;
      this.constantApproverIndex = constantApproverIndex;
      let entityId = this.formBuilder.advanced_approval_users[this.currentLevelIndex].constant_approvers[constantApproverIndex].application_user_type;
      this.selectedEntityFields = await this.getEntityFields(entityId);
      this.currentEntity = await fetchEntityById(entityId);
    },
    closeConstantApproverFilters() {
      this.openConstantApproverFilters = false;
    },
    reConfig() {
      this.formBuilder.advanced_approval_users = [];
    },
    isBasedOnFilledDataApproverLevel() {
      let selectedPreviousLevelData =
        this.formBuilder.advanced_approval_users[this.currentLevelIndex - 1];
      if (selectedPreviousLevelData.approver_type == "constant_approver") {
        let findBasedOnfilledData =
          selectedPreviousLevelData.constant_approvers.find(
            (e) => e.user_type == "LINKEDFIELD" && e.approval_linked_field
          );
        return findBasedOnfilledData ? true : false;
      }
      return false;
    },
    openBusinessRulesConfig(index) {
      this.currentLevelIndex = index;
      this.openBusinessRulesModel = true;
    },
    closeBusinessRulesModel() {
      this.openBusinessRulesModel = false;
    },
    async checkLevelIsBasedOnFilledData() {
      let selectedPreviousLevelData =
        this.formBuilder.advanced_approval_users[this.currentLevelIndex - 1];
      if (selectedPreviousLevelData.approver_type == "constant_approver") {
        let findBasedOnfilledData =
          selectedPreviousLevelData.constant_approvers.find(
            (e) => e.user_type == "LINKEDFIELD" && e.approval_linked_field
          );
        let entityId =
          findBasedOnfilledData.approval_linked_field.split("#")[1];
        let entityFields = await this.getEntityFields(entityId);
        let entityTypeFields = entityFields.filter(
          (f) => f.inputType == "ENTITY"
        );
        this.previousLevelApproverEntityFields = entityTypeFields;
      }
    },
    async getEntityFields(entity_id) {
      let fields = [];
      let entity = await fetchEntityById(entity_id);
      if (entity) {
        entity.templates.forEach((tem) => {
          fields = [
            ...fields,
            ...this.getFieldsFromTemplate(tem.templateInfo, entity, tem.customization),
          ];
        });
      }
      return fields;
    },
    getFieldsFromTemplate(data, entity,customization ={}) {
      let fields = [];
      let tempData = JSON.parse(JSON.stringify(data));
      let contentFields = [
        "HEADING",
        "PARAGRAPH",
        "HTML_CONTENT",
        "SINGLE_LINE_CONTENT",
        "VIDEO",
        "ACTION_BUTTON",
        "HORIZONTAL_LINE",
        "DIVISION",
      ];
      tempData.sections.forEach((e) => {
        fields = [
          ...fields,
          ...e.fields.filter((e) => contentFields.indexOf(e.inputType) === -1),
        ];
      });
      if (customization && Object.keys(customization).length > 0) {
        fields = this.applyCustomizationOnFields(fields, customization);
      }
      fields = fields.map((e) => {
        e.template_id = data._id;
        e.template_name = data.name;
        if (!e.template_key) {
          e.template_key = e.template_id + "#" + e.key;
        }
        if (!e.mention_key) {
          e.mention_key = e.template_id + "#" + e.key;
        }
        if (e.key && !e.key.includes("#")) {
          e.key = e.template_id + "#" + e.key;
        }
        e.label = entity.name + " - " + e.label;
        return e;
      });
      return fields;
    },
    getLevelLabel(index) {
      if (this.formBuilder.advanced_approval_users[index].role == "user") {
        return "Level-" + (index + 1) + " User";
      } else {
        return "Level-" + (index + 1) + " Approver";
      }
    },
    levelsExcludingLast() {
      return this.formBuilder.advanced_approval_users.slice(0, -1);
    },
    openUserConfig(index) {
      this.currentLevelIndex = index;
      this.openUserConfigModel = true;
    },
    closeUserConfigModel() {
      this.openUserConfigModel = false;
    },
    addLevel() {
      this.formBuilder.advanced_approval_users.push({
        role: "",
        user_usertype: "",
        approver_type: "",
        constant_approvers: [],
        selected_profile_attribute: "",
        conditions: [],
        business_rules: [],
        conflict_management: {
          assign_to_all_matched_users: "all_matched_users",
          assigned_approvers: []
        },
      });
    },
    async openApproversConfig(approverType, index) {
      this.currentLevelIndex = index;
      this.addInitialUsers();
      if (approverType == "constant_approver") {
        if (this.formBuilder?.advanced_approval_users?.[index]?.constant_approvers?.length) {
          let isResourceFilter = this.formBuilder.advanced_approval_users[index].constant_approvers.find(e => e.individual_entity_resource == "FILTER");
          if (isResourceFilter?.application_user_type) {
            await this.getFiltersByEntityId(isResourceFilter.application_user_type);
          }
        }
        this.getLevelProfileRelatedApprovers();
        this.openConstantApproversModel = true;
      } else if (approverType == "dynamic_attribute_based") {
        this.openAttributeBasedApproversModel = true;
      } else if (approverType == "approver_from_previous_level") {
        this.openPreviousApproversModel = true;
      }
    },
    closeConstantApproversModel() {
      this.openConstantApproversModel = false;
    },
    closeAttributeBasedApproversModel() {
      this.openAttributeBasedApproversModel = false;
    },
    closePreviousApproversModel() {
      this.openPreviousApproversModel = false;
    },
    addInitialUsers() {
      // if (
      //   !this.formBuilder?.advanced_approval_users?.[this.currentLevelIndex]
      //     ?.constant_approvers ||
      //   !this.formBuilder?.advanced_approval_users?.[this.currentLevelIndex]
      //     ?.constant_approvers?.length
      // ) {
      //   this.addApprovers();
      // }
    },
    getLabelForBusinessAccount(data) {
      if (
        data.entity_id &&
        data.entityData &&
        this.mappedEntityPrimaryFields[data.entity_id] &&
        this.mappedEntityPrimaryFields[data.entity_id].includes("#")
      ) {
        let [tempId, key] =
          this.mappedEntityPrimaryFields[data.entity_id].split("#");
        if (data.entityData[tempId] && data.entityData[tempId][key]) {
          return data.entityData[tempId][key + "/name"]
            ? data.entityData[tempId][key + "/name"]
            : data.entityData[tempId][key];
        } else if (data.entity_prime_data[key]) {
          return data.entity_prime_data[key];
        } else {
          return Object.keys(data.entity_prime_data) &&
            Object.keys(data.entity_prime_data)[0] &&
            data.entity_prime_data[Object.keys(data.entity_prime_data)[0]]
            ? data.entity_prime_data[Object.keys(data.entity_prime_data)[0]]
            : "";
        }
      }
    },
    async updatePreferredApplicationUsers(user) {
      let params = {
        contactType: user.application_user_type,
        accountName: user.application_user_business_account_id,
        limit: 10,
        page: 1,
      };
      const response = await postAPICall(
        "GET",
        `/contacts/${params.contactType}/${params.accountName}/list`,
        params
      );
      let contacts = response?.data || [];
      user.preferred_application_users = contacts?.map((c) => c.email);
    },
    async getBusinessAccountNames(contactType) {
      let params = {
        contact_types:
          typeof contactType == "string" ? [contactType] : contactType,
      };
      const data = await postAPICall("POST", "/entity/account-names", params);
      this.accountNamesObj = data.data;
      this.getAllContactTypes?.forEach((e) => {
        this.mappedEntityPrimaryFields[e._id] =
          e.primaryFields &&
          e.primaryFields[0] &&
          e.primaryFields[0].key &&
          e.primaryFields[0].template_id
            ? e.primaryFields[0].template_id + "#" + e.primaryFields[0].key
            : "";
      });
    },
    removeConstantApprover(index) {
      this.formBuilder?.advanced_approval_users?.[
        this.currentLevelIndex
      ]?.constant_approvers.splice(index, 1);
    },
    addApprovers() {
      this.formBuilder.advanced_approval_users[
        this.currentLevelIndex
      ].constant_approvers.push({
        user_type: "",
        application_user_type: "",
        preferred_application_users: [],        
        company_user_type: "",
        preferred_company_users: "",
        individual_entity_resource: "",      
        approval_linked_field: "",
        selected_entity_filter: "",
        filter_name: "",
        filters_data: {
          parentFilterId: "",
          query_type: "AND",
          filters: [],
          filter_name: "",
          isSaveFilter: false,
          data_limit: 10,
          columns_settings: [],
        }
      });
    },
    checkIsRelational(type) {
      if (
        this.formBuilder.form_builders_owner == "ENTITY" &&
        this.formBuilder.entity_id
      ) {
        return this.relationshipsData.find(
          (e) =>
            (e.child_entity_id == this.formBuilder.entity_id &&
              e.parent_entity_id == type) ||
            (e.child_entity_id == type &&
              e.parent_entity_id == this.formBuilder.entity_id)
        )
          ? true
          : false;
      }
      return false;
    },
     async openFormBuilderSettings(user, index) {
      try {
        if(user){
          this.fieldPermissionKey = `${user}#${index}`
        }
        const existingCustomization =
          this.formBuilder?.field_level_permissions?.[
            this.fieldPermissionKey
          ] || {};
        this.selectedFormBuilderCustomization = JSON.parse(
          JSON.stringify(existingCustomization)
        );
        this.fieldLevelPermissionsModal = true;
      } catch (err) {
        return err;
      }
    },
    saveCustomization(){
      this.fieldLevelPermissionsModal = false
    },
    handleUpdate(newCustomization) {
      try {
        if (!this.formBuilder.field_level_permissions) {
          this.$set(this.formBuilder, "field_level_permissions", {});
        }
        this.$set(
          this.formBuilder.field_level_permissions,
          this.fieldPermissionKey,
          newCustomization
        );
        this.fieldLevelPermissionsModal = false;
      } catch (err) {
        return err;
      }
    },
  },
};
</script>

<style scoped>
.advanced-approval-settings {
  font-family: Arial, sans-serif;
  padding: 20px;
}

.dialogStyle ::v-deep .dialog-content {
  scrollbar-width: none;
  overflow-y: hidden;
}
</style>
